import { autoUpdate as r, computePosition as u } from "../node_modules/.pnpm/@floating-ui_dom@1.6.13/node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
import { reactive as d, watch as f, toValue as n, onBeforeUnmount as p } from "vue";
function w(i, c, s) {
  const l = {
    x: 0,
    y: 0,
    placement: "top",
    strategy: "absolute",
    middlewareData: {}
  }, t = d(l);
  let a = () => {
  };
  return f([i, c, s], () => {
    const e = n(i), o = n(c);
    a(), Object.assign(t, l), e && o && (a = r(e, o, async () => {
      const m = await u(e, o, n(s));
      Object.assign(t, m);
    }));
  }, { immediate: !0 }), p(() => a()), t;
}
export {
  w as useFloatingUI
};
